import { Autocomplete } from '@mantine/core'
import { IconSearch } from '@tabler/icons-react'
import { useState } from 'react'
import { MYNAVI_PRIMARY } from '../Color'
import styles from './MyNaviInput.module.css'

export type MyNaviInputProps = {
  value?: string
  onChange?: (value: string) => void
  onSearch?: (value: string) => void
  placeholder?: string
  /** オートコンプリート候補 */
  data?: string[]
}

export const MyNaviInput = ({
  value,
  onChange,
  onSearch,
  placeholder = '学校名で検索',
  data = [],
}: MyNaviInputProps) => {
  const [internalValue, setInternalValue] = useState('')
  const currentValue = value ?? internalValue

  const handleChange = (v: string) => {
    setInternalValue(v)
    onChange?.(v)
  }

  return (
    <div style={{ display: 'flex', alignItems: 'stretch' }}>
      <Autocomplete
        value={currentValue}
        onChange={handleChange}
        placeholder={placeholder}
        data={data}
        classNames={{ option: styles.option }}
        styles={{
          root: { flex: 1 },
          input: {
            backgroundColor: '#fbfbfb',
            borderColor: '#686868',
            borderRight: 'none',
            height: '42px',
            borderRadius: '5px 0 0 5px',
            fontSize: '16px',
            color: '#686868',
          },
          dropdown: { zIndex: 9999 },
        }}
      />
      <button
        type="button"
        aria-label="検索"
        onClick={() => onSearch?.(currentValue)}
        style={{
          backgroundColor: MYNAVI_PRIMARY,
          width: '44px',
          height: '42px',
          borderRadius: '0 5px 5px 0',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <IconSearch size={20} color="white" stroke={2} />
      </button>
    </div>
  )
}
